import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LanguageTranslationService } from '../../services/language-translation.service';
import { TranslatePipe } from '../../translate-pipe.pipe';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.css'],
   providers: [TranslatePipe]
})
export class TermsAndConditionsComponent implements OnInit {

  countryCode: string;
  languageCode: string;
  country: string;
  language: string;
  showTranslatedText: boolean = false;
  showPHConditions: boolean = false;
  subscription: Subscription;
  conditionsUrl: string;
  translationCountries: string[] = ['de', 'nl','gb','ie','fr'];

  constructor(
    private languageTranslationService: LanguageTranslationService,
    private route: ActivatedRoute,
    private translatePipe: TranslatePipe
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.countryCode = params.get('countryCode'); 
      this.languageCode = params.get('languageCode');
    });
    this.languageTranslationService.useLang(this.languageCode,this.countryCode);
  }

  public getTranslatedText(tag: string): string {
    return this.translatePipe.transform(tag);
  }

}
